import { render, staticRenderFns } from "./CollectivityProductsSitecore.vue?vue&type=template&id=f7253c2c"
import script from "./CollectivityProductsSitecore.vue?vue&type=script&lang=js"
export * from "./CollectivityProductsSitecore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports